<wiz-vgroup #filterContainer [ngClass]="injectClass" width="100%" height="100%" 
  verticalAlign="center" gap="0" class="basicInput">
  <wiz-hgroup width="100%" verticalAlign="center">
    <wiz-label width="100%" id="label" [wizLabel]="filterNameLbl"></wiz-label>
    <wiz-icon id="ico" [hidden]="!data.active || isMeFilter || isBoolFilter" style="cursor: pointer;" (click)="clearFilter(true)">close</wiz-icon>
  </wiz-hgroup>

  <wiz-hgroup width="100%" height="20px" verticalAlign="center">
    
    <wiz-text-input #tiFree id="inzone"
      width="100%" (wizChange)="quickFilter($event)" [wizValue]="freeFilterValue"
      wizShowLabel="false" *ngIf="!!isFreeFilter">
    </wiz-text-input>

    <wiz-hgroup id="inzone" height="100%" verticalAlign="center" *ngIf="!!isMeFilter" >
      <wiz-checkbox #cbMe wizShowLabel="false" width="30px"
      [wizChecked]="meFilterValue" (wizClick)="quickMeFilter($event)"></wiz-checkbox>
    </wiz-hgroup>

    
    <wiz-hgroup id="inzone" height="100%" verticalAlign="center" *ngIf="!!isBoolFilter"  >
      <wiz-checkbox #cbBool wizShowLabel="false" width="30px"
      [wizTriStateMode]="true"
      [wizCheckState]="boolFilterValue" (wizClick)="quickBoolFilter($event)"></wiz-checkbox>
    </wiz-hgroup>


    <wiz-label *ngIf="!isFreeFilter && !isMeFilter && !isBoolFilter" id="inzone"
      [wizLabel]="filterContentLbl"
      [wizTextBehavior]="'truncate'"
      class="wiz-component-field"

      height="100%"
      style="font-weight: normal;"
      [style.width.px]="contentGoodWidth"
    ></wiz-label>
    <wiz-icon #btshowPop id="ico" [visible]="!isFreeFilter && !isMeFilter && !isBoolFilter" style="cursor: pointer" (click)="showHidePop()">arrow-down</wiz-icon>
  </wiz-hgroup>
  <span #block width="1px"></span>
</wiz-vgroup>
